import { Currency } from '@calo/types';
class PricingService {
    static getVATForNetAmount(netAmount, currency) {
        switch (currency) {
            case Currency.BHD:
                return this.roundAmount(netAmount * 0.1, currency);
            case Currency.SAR:
                return this.roundAmount(netAmount * 0.15, currency);
            case Currency.AED:
                return this.roundAmount(netAmount * 0.05, currency);
            case Currency.KWD:
                return 0;
            case Currency.OMR:
                return this.roundAmount(netAmount * 0.05, currency);
            default:
                return this.roundAmount(netAmount * 0.1, currency);
        }
    }
    static getVATFromAmount(totalAmount, currency) {
        switch (currency) {
            case Currency.BHD:
                return +(totalAmount * 0.1).toFixed(3);
            case Currency.SAR:
                return +(totalAmount * 0.15).toFixed(2);
            case Currency.AED:
                return +(totalAmount * 0.05).toFixed(2);
            case Currency.KWD:
                return 0;
            case Currency.OMR:
                return +(totalAmount * 0.05).toFixed(3);
            default:
                return +(totalAmount * 0.1).toFixed(3);
        }
    }
    static getVATFromGrossAmount(grossAmount, currency) {
        switch (currency) {
            case Currency.BHD:
                return this.roundAmount((grossAmount * 10) / 110, currency);
            case Currency.SAR:
                return this.roundAmount((grossAmount * 15) / 115, currency);
            case Currency.AED:
                return this.roundAmount((grossAmount * 5) / 105, currency);
            case Currency.KWD:
                return 0;
            case Currency.OMR:
                return this.roundAmount((grossAmount * 5) / 105, currency);
            default:
                return this.roundAmount((grossAmount * 10) / 110, currency);
        }
    }
    static getVATFromTotalAmount(grossAmount, currency) {
        switch (currency) {
            case Currency.BHD:
                return +((grossAmount * 10) / 110).toFixed(3);
            case Currency.SAR:
                return +((grossAmount * 15) / 115).toFixed(2);
            case Currency.AED:
                return +((grossAmount * 5) / 105).toFixed(2);
            case Currency.KWD:
                return 0;
            case Currency.OMR:
                return +((grossAmount * 5) / 110).toFixed(3);
            default:
                return +((grossAmount * 10) / 110).toFixed(3);
        }
    }
    static getMonthlyDiscount(currency) {
        switch (currency) {
            case Currency.BHD:
                return 20;
            case Currency.SAR:
                return 200;
            case Currency.AED:
                return 200;
            case Currency.KWD:
                return 20;
            case Currency.OMR:
                return 20;
            default:
                return 20;
        }
    }
    static getGrossAmount(netAmount, currency) {
        switch (currency) {
            case Currency.BHD:
                return this.roundAmount(netAmount * 1.1, currency);
            case Currency.SAR:
                return this.roundAmount(netAmount * 1.15, currency);
            case Currency.AED:
                return this.roundAmount(netAmount * 1.05, currency);
            case Currency.KWD:
                return this.roundAmount(netAmount * 1, currency);
            case Currency.OMR:
                return this.roundAmount(netAmount * 1.05, currency);
            default:
                return this.roundAmount(netAmount * 1.1, currency);
        }
    }
    static getPriceWithVAT(totalAmount, currency) {
        switch (currency) {
            case Currency.BHD:
                return +(totalAmount * 1.1).toFixed(3);
            case Currency.SAR:
                return +(totalAmount * 1.15).toFixed(2);
            case Currency.AED:
                return +(totalAmount * 1.05).toFixed(2);
            case Currency.KWD:
                return +(totalAmount * 1).toFixed(2);
            case Currency.OMR:
                return +(totalAmount * 1.05).toFixed(3);
            default:
                return +(totalAmount * 1.1).toFixed(3);
        }
    }
    static getNetAmount(grossAmount, currency) {
        return this.roundAmount(grossAmount - this.getVATFromGrossAmount(grossAmount, currency), currency);
    }
    static getGrossAmountWithDiscount(netAmount, discount, currency) {
        return this.getGrossAmount(netAmount - discount, currency);
    }
    static getTotalAmountWithDiscount(amount, discount, currency) {
        return this.getPriceWithVAT(amount - discount, currency);
    }
    static roundAmount(amount, currency) {
        switch (currency) {
            case Currency.BHD:
                return +(amount).toFixed(3);
            case Currency.SAR:
                return +(amount).toFixed(2);
            case Currency.AED:
                return +(amount).toFixed(2);
            case Currency.KWD:
                return +(amount).toFixed(3);
            case Currency.OMR:
                return +(amount).toFixed(3);
            default:
                return +(amount).toFixed(3);
        }
    }
}
export default PricingService;
